import { Component, Input, OnInit } from '@angular/core';
import {
  ESection,
  HomeCardItemInterface,
} from 'src/app/interfaces/home-card-item-interface';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-home-button-card',
  templateUrl: './home-button-card.component.html',
  styleUrls: ['./home-button-card.component.scss'],
})
export class HomeButtonCardComponent implements OnInit {
  @Input() currentUser!: User;
  ESection = ESection;
  CARD_ITEMS: HomeCardItemInterface[] = [
    {
      title: 'home.cards.orders.title',
      image: '/assets/images/order.png',
      text1: 'home.cards.orders.text1',
      text2: 'home.cards.orders.text2',
      link: '/orders',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'Précommandeur'],
      sections: [ESection.MT],
    },
    {
      title: 'home.cards.performances.title',
      image: '/assets/images/performance.png',
      text1: 'home.cards.performances.text1',
      text2: 'home.cards.performances.text2',
      link: '/performances',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'Précommandeur'],
      sections: [ESection.MT],
    },
    {
      title: 'home.cards.truckLoadingsMt.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.truckLoadingsMt.text1',
      text2: 'home.cards.truckLoadingsMt.text2',
      link: '/loadings',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'Précommandeur'],
      sections: [ESection.MT],
    },
    {
      title: 'home.cards.truckLoadingsForecasts.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.truckLoadingsForecasts.text1',
      text2: 'home.cards.truckLoadingsForecasts.text2',
      link: '/forecasts',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'superviseur'],
      sections: [ESection.TRADI],
    },
    {
      title: 'home.cards.usersManagement.title',
      image: '/assets/images/team.png',
      text1: 'home.cards.usersManagement.text1',
      text2: 'home.cards.usersManagement.text2',
      link: '/users',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin'],
      sections: [ESection.ADMIN],
    },
    {
      title: 'home.cards.rolesManagement.title',
      image: '/assets/images/management.png',
      text1: 'home.cards.rolesManagement.text1',
      text2: 'home.cards.rolesManagement.text2',
      link: '/roles',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin'],
      sections: [ESection.ADMIN],
    },
    {
      title: 'home.cards.permissionsManagement.title',
      image: '/assets/images/permission.png',
      text1: 'home.cards.permissionsManagement.text1',
      text2: 'home.cards.permissionsManagement.text2',
      link: '/permissions',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin'],
      sections: [ESection.ADMIN],
    },
    {
      title: 'home.cards.loadingRequests.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.loadingRequests.text1',
      text2: 'home.cards.loadingRequests.text2',
      link: '/request-loadings/loading-requests',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'superviseur', 'chef de quart'],
      sections: [ESection.LOGISTIQUE],
    },
    {
      title: 'home.cards.loadingsManagement.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.loadingsManagement.text1',
      text2: 'home.cards.loadingsManagement.text2',
      link: '/request-loadings/loading-logistics',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'superviseur', 'chef de quart'],
      sections: [ESection.LOGISTIQUE],
    },
    {
      title: 'home.cards.additionalLoadings.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.additionalLoadings.text1',
      text2: 'home.cards.additionalLoadings.text2',
      link: '/request-loadings/additionnal-loading-logistics',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', '', 'chef de quart'],
      sections: [ESection.LOGISTIQUE],
    },
    {
      title: 'home.cards.pointsOfSaleManagement.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.pointsOfSaleManagement.text1',
      text2: 'home.cards.pointsOfSaleManagement.text2',
      link: '/point_of_sales_tradi',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'superviseur', 'Business Developper'],
      sections: [ESection.TRADI],
    },
    {
      title: 'home.cards.depotStockTracking.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.depotStockTracking.text1',
      text2: 'home.cards.depotStockTracking.text2',
      link: '/stock-controls',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin', 'chef de quart'],
      sections: [ESection.LOGISTIQUE],
    },
    {
      title: 'home.cards.trucksAdministration.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.trucksAdministration.text1',
      text2: 'home.cards.trucksAdministration.text2',
      link: '/gestion-of-trucks',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin'],
      sections: [ESection.LOGISTIQUE],
    },
    {
      title: 'home.cards.toursAdministration.title',
      image: '/assets/images/delivery-truck.png',
      text1: 'home.cards.toursAdministration.text1',
      text2: 'home.cards.toursAdministration.text2',
      link: '/list-tour-logistic',
      linkClass: ['text-decoration-none'],
      authorizedRoles: ['admin'],
      sections: [ESection.LOGISTIQUE],
    },
  ];
  constructor() { }

  ngOnInit(): void { }

  getSectionAuthorizeRole(authorizedRoles: string[]) {
    return authorizedRoles.includes(this.currentUser.role?.libelle!);
  }

  getCardSectionSection(cardSections: ESection[], currentSection: ESection) {
    return cardSections.includes(currentSection);
  }
}
